import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CAM_AUTH_TOKEN } from '../../../services/auth.service';

@Component({
  host: { 'data-cid': 'login-redirect' },
  selector: '',
  template: '',
  standalone: true,
})
export class LoginRedirectComponent {
  private _authService = inject(CAM_AUTH_TOKEN);
  private _route = inject(ActivatedRoute);

  constructor() {
    this._authService.login(this._route.snapshot.queryParamMap.get('redirectTo') ?? undefined);
  }
}
